import { render, staticRenderFns } from "./addBuild.vue?vue&type=template&id=634b8df0&scoped=true&"
import script from "./addBuild.vue?vue&type=script&lang=ts&"
export * from "./addBuild.vue?vue&type=script&lang=ts&"
import style0 from "./addBuild.vue?vue&type=style&index=0&id=634b8df0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634b8df0",
  null
  
)

export default component.exports